export const fieldTypeOptions = [
  { id: "int", name: "Int" },
  { id: "instance_id", name: "Instance ID" },
  { id: "fk", name: "Foreign Key" },
  { id: "pk", name: "Primary Key" },
  { id: "varchar", name: "Varchar" },
  { id: "date", name: "Date" },
  { id: "time", name: "Time" },
  { id: "datetime", name: "DateTime" },
  { id: "file", name: "File" },
  { id: "recordset-list", name: "Recordset List" },
  { id: "array", name: "Array" }
];

export function isNamePresent(arr, name) {
  for (let obj of arr) {
    if (obj.name.trim() === name) {
      return true;
    }
    if (obj.type === "recordset-list" && obj.sub_fields && obj.sub_fields.length > 0) {
      if (isNamePresent(obj.sub_fields, name)) {
        return true;
      }
    }
  }
  return false;
}
